import { ProfessionalReferencesWorkflowView } from "./components/WorkflowView";

/**
 * Professional References Page
 */
export function DocumentDetailsProfessionalReferencesWorkflowPage() {
  return <ProfessionalReferencesWorkflowView />;
}
